import { object } from "../helpers/object";
import { debug } from "../helpers/debug";
import { responsive } from "../helpers/responsive";
import { throttle } from "throttle-debounce";

/*------------------------------------*\
  #TEXT RESPONSIVE

  Class gestion des element [data-js-component="text-responsive"]

  [data-js-component="text-responsive"]
  [data-js-text-responsive-default="{string}"] // texte par défaut
  [data-js-text-responsive-sm="{string}"] // texte de remplacement pour sm
  [data-js-text-responsive-md="{string}"] // texte de remplacement pour md
  [data-js-text-responsive-lg="{string}"] // texte de remplacement pour lg
  [data-js-text-responsive-xl="{string}"] // texte de remplacement pour xl
  [data-js-text-responsive-xl-max="{string}"] // texte de remplacement pour xl-max
\*------------------------------------*/
class TextResponsive {

  constructor(module){
    this.MODULE = module;
    this.DOM_MODULE = object.toArray(document.querySelectorAll(this.MODULE));
  }
  /**
   * INITIALISATION
   * @returns 
   */
  init = () => {
    if (!this.DOM_MODULE.length) return;
    this.responsiveHandler();
    if(debug.DEBUG) console.log('components/text-responsive.js');
  };

  /**
   * RESPONSIVE
   * 
   * Gestion de la maj du component
   * en fonction du media query
   */
  responsiveHandler = () => {
    document.addEventListener('RESPONSIVE_HAS_CHANGED', (event) => {
      this.textChanger();
    });
    this.textChanger();
  }
  /**
   * TEXT CHANGER
   * 
   * Modification de l'affichage en
   * fonction du media query
   */
  textChanger = throttle(100, () => {
    const screen = responsive.screen;
    const availableScreens = ['mobile', 'md', 'lg', 'xl', 'xl-max'];
    
    this.DOM_MODULE.forEach(element => {
      // Try to find a breakpoint-specific attribute matching current screen
      let text = null;
      
      for (const breakpoint of availableScreens) {
        if (screen === breakpoint) {
          const attribute = `data-js-text-responsive-${breakpoint}`;
          text = element.getAttribute(attribute);
          if (text) break;
        }
      }
      
      // Fallback to default if no breakpoint-specific text found
      if (!text) {
        text = element.getAttribute('data-js-text-responsive-default');
      }
      
      // Update text if we found a value
      if (text) {
        element.innerText = text;
        element.classList.remove('u-hidden');
      }
    });
  });
}
export const textResponsive = new TextResponsive('[data-js-component="text-responsive"]');